import DonateModal from '../components/popper/DonateModal';

const DonatePage = () => {
  return (
    <div className='container'>
      <DonateModal />
    </div>
  );
};

export default DonatePage;
